import colors from "../../base/colors";
import root from "../button/root";
import contained from "../button/contained";
import outlined from "../button/outlined";
import buttonText from "../button/text";

const { grey, text } = colors;

const button = {
  defaultProps: {
    disableRipple: false,
    size: "medium",
  },
  styleOverrides: {
    root: { ...root },
    contained: { ...contained.base },
    containedSizeSmall: { ...contained.small },
    containedSizeLarge: { ...contained.large },
    containedPrimary: { ...contained.primary },
    containedSecondary: { ...contained.secondary },
    containedSuccess: { ...contained.success },
    containedWarning: { ...contained.warning },
    containedError: { ...contained.error },
    containedInfo: { ...contained.info },
    outlined: { ...outlined.base },
    outlinedSizeSmall: { ...outlined.small },
    outlinedSizeLarge: { ...outlined.large },
    outlinedPrimary: { ...outlined.primary },
    outlinedSecondary: { ...outlined.secondary },
    outlinedSuccess: { ...outlined.success },
    outlinedWarning: { ...outlined.warning },
    outlinedError: { ...outlined.error },
    outlinedInfo: { ...outlined.info },
    outlinedInherit: {
      color: text.main,
      borderColor: grey[400],
      "&:hover": {
        backgroundColor: grey[100],
        borderColor: grey[500],
      },
    },
    text: { ...buttonText.base },
    textSizeSmall: { ...buttonText.small },
    textSizeLarge: { ...buttonText.large },
    textPrimary: { ...buttonText.primary },
    textSecondary: { ...buttonText.secondary },
  },
};

export default button;
